<template>
  <div>
    <Form :description-title="'Atualize os dados dessa noticia'">
      <CreateButton
        @click="updateSector()"
        :icon="PhNotePencil"
        :label="'Atualizar'"
      />
    </Form>
  </div>
</template>

<script setup>
import ExtinguisherService from '../service/extinguisher.service'
import CreateButton from '@/components/Buttons/Create.vue'
import Form from '../components/RegisterForm.vue'
import {
  cleanAllFormFields,
  setFormFieldsError,
  validateFormField
} from '@/helpers/formFieldsHandler'
import { showToast as toast } from '@/helpers/UseToasts'
import { PhNotePencil } from '@phosphor-icons/vue'
import { dataExtinguisher } from '../store'
import { storeApp } from '@/store'
import * as yup from '@/validator'

const store = dataExtinguisher.state
const appStore = storeApp.state

const schema = yup.object().shape({
  sectorForm: yup.object().shape({
    title: yup.string().required('Informe um titulo').label('Titulo')
  })
})

async function updateSector () {
  appStore.loading = true

  cleanAllFormFields()
  const validate = await validateFormField(schema, store)

  if (validate && validate.length > 0) {
    setFormFieldsError(validate)
    appStore.loading = false
    return
  }

  // fluxo da imagem
  if (
    store.sectorForm.image &&
    typeof store.sectorForm.image === 'object' &&
    typeof store.sectorForm.imageName === 'string' &&
    store.sectorForm.image != '[]'
  ) {
    await ExtinguisherService.saveImage(store.sectorForm.image)
      .then((res) => {
        store.sectorForm.banner = process.env.VUE_APP_IMAGE_SERVE + 'storage/' + res.data
      })
      .catch((err) => toast('Aviso', 'Imagem não foi salva', 'error'))
  } else if (
    store.sectorForm.image &&
    typeof store.sectorForm.image !== 'string'
  ) {
    await ExtinguisherService.saveImage(store.sectorForm.image)
      .then((res) => {
        store.sectorForm.banner = process.env.VUE_APP_IMAGE_SERVE + 'storage/' + res.data
      })
      .catch((err) => toast('Aviso', 'Imagem não foi salva', 'error'))
  }

  delete store.sectorForm.imageName
  delete store.sectorForm.image

  await ExtinguisherService.registerNotice(store.sectorForm)
    .then((res) => {
      if (res?.data?.success) {
        toast(
          'Sucesso',
          res?.data?.message,
          'success'
        )

        Promise.allSettled([
          ExtinguisherService.getNotices()
            .then((res) => {
              dataExtinguisher.dispatch('setAllSectors', res.data.notices)
            })
        ])
      }

      appStore.loading = false
    })
    .catch((err) => {
      appStore.loading = false

      if (err?.response?.data?.error && err.response.data.status === 400) {
        return toast('Aviso', err.response.data.message, 'error')
      }

      return toast('Aviso', 'Algo deu errado ao registrar documento', 'error')
    })
}
</script>
